import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { configureAmplify } from './aws-config'

// Polyfill for AWS SDK v3 in browser environment
if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}

// Configure AWS Amplify
configureAmplify()

// Log environment variables to help with debugging
console.log('Environment variables:', {
  API_URL: process.env.REACT_APP_API_URL,
  REGION: process.env.REACT_APP_REGION,
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
)
